/**
 * The `public` middleware should be applied to routes that should
 * be accessible to anyone (both authenticated & unauthenticated users),
 * e.g. homepage, public Sustainability IDs, t&c, privacy policy, etc.
 *
 */
export default defineNuxtRouteMiddleware(() => {
  // no-op
})
